import emailjs from '@emailjs/browser';
import { EMAIL_CONFIG } from '../config/emailConfig';

class EmailService {
  constructor() {
    // Initialiser EmailJS avec votre User ID
    this.initialized = false;
  }

  async initialize() {
    if (!this.initialized) {
      await emailjs.init(EMAIL_CONFIG.USER_ID);
      this.initialized = true;
    }
  }

  async sendEmail(formData) {
    try {
      // S'assurer qu'EmailJS est initialisé
      await this.initialize();

      // Préparer les paramètres du template
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        subject: formData.subject,
        message: formData.message,
        to_email: EMAIL_CONFIG.TO_EMAIL,
        reply_to: formData.email
      };

      console.log('Configuration EmailJS:', {
        serviceId: EMAIL_CONFIG.SERVICE_ID,
        templateId: EMAIL_CONFIG.TEMPLATE_ID,
        userId: EMAIL_CONFIG.USER_ID
      });

      // Envoyer l'email
      const response = await emailjs.send(
        EMAIL_CONFIG.SERVICE_ID,
        EMAIL_CONFIG.TEMPLATE_ID,
        templateParams
      );

      console.log('Email envoyé avec succès:', response);
      return { success: true, message: 'Message envoyé avec succès !' };
    } catch (error) {
      console.error('Erreur lors de l\'envoi de l\'email:', error);
      console.error('Détails de l\'erreur:', {
        status: error.status,
        text: error.text,
        message: error.message
      });

      let errorMessage = 'Erreur lors de l\'envoi du message. Veuillez réessayer.';

      if (error.status === 400) {
        errorMessage = 'Configuration EmailJS invalide. Vérifiez vos clés.';
      } else if (error.status === 401) {
        errorMessage = 'Clé API EmailJS invalide.';
      } else if (error.status === 403) {
        errorMessage = 'Accès refusé. Vérifiez vos permissions EmailJS.';
      }

      return {
        success: false,
        message: errorMessage
      };
    }
  }

  // Méthode de test pour vérifier la configuration
  async testConnection() {
    try {
      // S'assurer qu'EmailJS est initialisé
      await this.initialize();

      // Test simple pour vérifier que EmailJS est bien configuré
      const testParams = {
        from_name: 'Test',
        from_email: 'test@example.com',
        subject: 'Test de connexion',
        message: 'Ceci est un test',
        to_email: EMAIL_CONFIG.TO_EMAIL
      };

      console.log('Test de configuration EmailJS...');
      console.log('Configuration:', {
        serviceId: EMAIL_CONFIG.SERVICE_ID,
        templateId: EMAIL_CONFIG.TEMPLATE_ID,
        userId: EMAIL_CONFIG.USER_ID
      });

      await emailjs.send(
        EMAIL_CONFIG.SERVICE_ID,
        EMAIL_CONFIG.TEMPLATE_ID,
        testParams
      );

      return { success: true, message: 'Configuration EmailJS valide - Test réussi !' };
    } catch (error) {
      console.error('Erreur de test EmailJS:', error);
      return {
        success: false,
        message: `Configuration EmailJS invalide: ${error.text || error.message}`
      };
    }
  }
}

const emailService = new EmailService();
export default emailService;
